module.exports = __webpack_public_path__ + "files/Puncture.5a4f04e11f1ba72e680a5e9f090e772b.png";